var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_1213_329679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19644 12.7225C0.583757 11.6564 0.583757 10.3436 1.19644 9.27754L5.11242 2.46359C5.7267 1.39472 6.86294 0.736927 8.09179 0.736927L15.9082 0.736927C17.1371 0.736927 18.2733 1.39472 18.8876 2.46359L22.8036 9.27755C23.4162 10.3436 23.4162 11.6564 22.8036 12.7225L18.8876 19.5364C18.2733 20.6053 17.1371 21.2631 15.9082 21.2631L8.09179 21.2631C6.86294 21.2631 5.7267 20.6053 5.11242 19.5364L1.19644 12.7225Z",
    stroke: "#E9BE5C",
    strokeWidth: 1.47386
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 8.5793C14.27 8.5793 16.7137 8.10999 16.7137 7.07949C16.7137 6.049 14.27 5.55969 11.9994 5.55969C9.72889 5.55969 7.28516 6.049 7.28516 7.07949C7.28516 8.10999 9.72889 8.5793 11.9994 8.5793Z",
    fill: "#E9BE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 9.22361C10.6995 9.22361 8.29136 9.00787 7.29776 8.15445C7.29146 8.15445 7.29146 8.14795 7.28516 8.14795C7.28516 9.45429 9.75967 9.75271 11.0566 9.8392V10.4872C9.92516 10.4159 8.20289 10.1826 7.28516 9.4569V9.5476C7.28516 10.8306 10.3715 11.1676 11.9994 11.1676C13.6274 11.1676 16.7137 10.8306 16.7137 9.5476V8.14795C15.531 9.0196 13.4443 9.22361 11.9994 9.22361ZM12.3137 10.5196H11.6852V9.8716H12.3137V10.5196Z",
    fill: "#E9BE5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 11.6546C10.7036 11.6546 8.27851 11.4654 7.29776 10.7418C7.29146 10.7418 7.29146 10.7362 7.28516 10.7362C7.28516 11.851 9.78086 12.1103 11.0566 12.1834V12.74C9.92516 12.6788 8.20289 12.4784 7.28516 11.855C7.28516 13.1185 10.6181 13.3244 11.9994 13.3244C13.6274 13.3244 16.7137 13.035 16.7137 11.9329V10.7362C15.5367 11.4805 13.4141 11.6546 11.9994 11.6546ZM12.3137 12.7678H11.6852V12.2112H12.3137V12.7678Z",
    fill: "#E9BE5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29776 12.8997C7.29146 12.8997 7.29146 12.8932 7.28516 12.8932C7.28516 14.1845 9.78086 14.4849 11.0566 14.5696V15.2143C9.92516 15.1434 8.20289 14.9112 7.28516 14.1892C7.28516 15.6546 10.5839 15.9128 11.9994 15.9128C14.2686 15.9128 16.7137 15.3883 16.7137 14.2794V12.8932C15.4566 13.8926 12.6846 13.957 11.9994 13.957C11.3143 13.957 8.56121 13.8926 7.29776 12.8997ZM12.3137 15.2465H11.6852V14.6018H12.3137V15.2465Z",
    fill: "#E9BE5C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_1213_329679",
    x: -12.1347,
    y: -12.1347,
    width: 48.2693,
    height: 46.2693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.06733
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1213_329679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1213_329679",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.86687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.933436
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1213_329679"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.8684
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1213_329679",
    result: "effect3_innerShadow_1213_329679"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.c06a9a989e055ebd702904b9bb08a7a6.svg";
export { ForwardRef as ReactComponent };